import './Features.css';
const features = [
  {
    icon: '✅',
    title: 'Verified Properties',
    description: 'Our field executive personally visits each property to record complete data — rooms, washrooms, water taps, ventilation, and surroundings.',
  },
  {
    icon: '📦',
    title: 'Free Packing Cartons',
    description: 'Get complimentary packing cartons to make your move easier. No extra cost, no hassle.',
  },
  {
    icon: '💪',
    title: 'Free Moving Support',
    description: 'Enjoy free helper support with trained manpower and coordination for a smooth, stress-free move.',
  },
  {
    icon: '🧼',
    title: 'Home Cleaning Support',
    description: 'Cleaning support for kitchen, bathrooms, and living spaces to help you move into a fresh and ready home.',
  },
   {
    icon: '🔄',
    title: 'End-to-End Service',
    description: 'From finding the right room to moving in — everything is handled by RoomBuddy with care.',
  },
  {
    icon: '🤝',
    title: 'Transparent & Honest',
    description: 'No hidden charges, no fake listings. Only verified and genuine rental homes shared with customers.',
  },
];
const Features = () => {
  return (
    <section className="features" id="features">
      <div className="features-container">
        <div className="features-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">Why Choose RoomBuddy?</h2>
          <p className="section-subtitle">
            We provide a complete rental solution — from verified homes to stress-free moving assistance.
          </p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Features;